<template lang="pug">
  div.user-views
    module-title(title="网民观点")
    div.navs
      button.nav(:class="{active: type === 'before'}" @click.prevent.stop="type = 'before'" v-if="views.before.length") 回应前
      button.nav(:class="{active: type === 'after'}" @click.prevent.stop="type = 'after'" v-if="views.after.length") 回应后
    div.table
      div.th
        div.th_item.center(style="flex: 4;") 观点
        div.th_item(style="flex: 12;")
          div.th_item_li.left(style="flex: 10;") 观点呈现
          div.th_item_li(style="flex: 2;") 点赞数
      div.td(v-for="(view, $i) in views[type]" :key="$i" :style="{height: `${view.commentDetails.length * 60}px`}")
        div.td_item.comment(style="flex: 4;") {{view.comment}}
        div.td_item(style="flex: 12;")
          div.td_items(v-for="cmt in view.commentDetails")
            div.td_item_li.left(style="flex: 10;") {{cmt.content}}
            div.td_item_li(style="flex: 2;") {{cmt.likeNum}}
</template>

<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import client from '../server/server'
export default {
  name: 'UserViews',
  components: {
    ModuleTitle
  },
  data () {
    return {
      type: 'before',
      views: {
        before: [],
        after: []
      }
    }
  },
  mounted () {
    this.getUserViews()
  },
  methods: {
    getUserViews () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventUserViews(params)
        .then(res => {
          if (res.code === 200) {
            this.views = Object.assign({}, this.views, res.data)
            if (!this.views.before.length) {
              this.type = 'after'
            }
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/common";
  .user-views{
    flex: 9;
    height: 760px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 14px;
    .navs{
      text-align: right;
      .nav{
        width: 60px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        border-radius: 13px;
        font-size: 12px;
        outline: none;
        border: none;
        background-color: #fff;
        &.active{
          color: #f87653;
          background-color: #fdeee8;
        }
      }
    }
    .table{
      margin: 20px 0;
      height: 660px;
      overflow-y: auto;
      @include scrollBar;
    }
    .th{
      display: flex;
      align-items: center;
      background-color: #3989cb;
      height: 40px;
      color: #fff;
      .th_item{
        display: flex;
        align-items: center;
        &.center{
          justify-content: center;
        }
      }
      .th_item_li{
        display: flex;
        align-items: center;
        justify-content: center;
        &.left{
          justify-content: flex-start;
          margin-left: 10px;
        }
      }
    }
    .td{
      display: flex;
      align-items: center;
      border-bottom: 1px solid #ddd;
      border-left: 1px solid #ddd;
      border-right: 1px solid #ddd;
      min-height: 60px;
      &:nth-of-type(odd){
        background-color: #f9f9f9;
      }
      .td_item{
        height: 100%;
        color: #666;
        &:first-child{
          border-right: 1px solid #ddd;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        &.comment{
          color: #333;
        }
        .td_items{
          height: 59px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #ddd;
          &:last-child{
            border-bottom: none;
          }
          .td_item_li{
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            &.left{
              justify-content: flex-start;
              margin-left: 10px;
              a{
                cursor: pointer;
                text-decoration: none;
                &:hover{
                  color: #227bff;
                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/EventViews/UserViews.vue